import { useGetProductConfigForPayerQuery } from 'store/api/referenceApi';

/** Enum for preferred billing types */
export const PreferredBillingTypes = {
    MEDICAL: 'MEDICAL',
    PHARMACY: 'PHARMACY',
};

export const useProductConfig = ({ segmentId, productServiceOid, billing }) => {
    const { data } = useGetProductConfigForPayerQuery(
        { segmentId, productServiceOid },
        { skip: !segmentId || !productServiceOid },
    );
    return data?.find((config) => config.preferredBillingType === billing);
};

export const useProductConfigList = ({ segmentId, productServiceOid }) => {
    const { data } = useGetProductConfigForPayerQuery(
        { segmentId, productServiceOid },
        { skip: !segmentId || !productServiceOid },
    );
    return data;
};

/** Gets proper display units for the est dispensed quantity value  */
export const getEstDispensedQtyUnits = (productConfig) => {
    if (productConfig?.preferredBillingType === PreferredBillingTypes.MEDICAL) {
        return productConfig.hcpcsBillingLabel;
    }
    if (productConfig?.preferredBillingType === PreferredBillingTypes.PHARMACY) {
        return productConfig.ndcBillingLabel;
    }
    return undefined;
};

/** Adds display units to the quantity values */
export const addQtyUnits = (qty, units) => (qty ? `${qty}${units ? ` ${units}` : ''}` : undefined);
